import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../services/authService';
import { colors } from '../styles/colors';

interface CandidateProfile {
  id?: number;
  candidate_id: number;
  name?: string;
  lastname?: string;
  birthdate?: string;
  description?: string;
  street?: string;
  number?: string;
  complement?: string;
  zip?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
  cellphone?: string;
  cv_link?: string;
  portfolio_link?: string;
}

interface CandidateProfileFormProps {
  candidateId: number;
  onSave: () => void;
  onCancel: () => void;
}

const CandidateProfileForm: React.FC<CandidateProfileFormProps> = ({ candidateId, onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [description, setDescription] = useState('');
  const [street, setStreet] = useState('');
  const [number, setNumber] = useState('');
  const [complement, setComplement] = useState('');
  const [zip, setZip] = useState('');
  const [neighborhood, setNeighborhood] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [cellphone, setCellphone] = useState('');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProfile();
  }, [candidateId]);

  const fetchProfile = async () => {
    try {
      const response = await api.get(`/candidate-profiles/${candidateId}`);
      const profile = response.data;
      
      setName(profile.name || '');
      setLastname(profile.lastname || '');
      setBirthdate(profile.birthdate ? profile.birthdate.split('T')[0] : '');
      setDescription(profile.description || '');
      setStreet(profile.street || '');
      setNumber(profile.number || '');
      setComplement(profile.complement || '');
      setZip(profile.zip || '');
      setNeighborhood(profile.neighborhood || '');
      setCity(profile.city || '');
      setState(profile.state || '');
      setCellphone(profile.cellphone || '');

    } catch (error: any) {
      // Profile doesn't exist yet, that's ok
      console.log('Profile not found, will create new one');
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = {
        name, lastname, birthdate, description, street, number, complement,
        zip, neighborhood, city, state, cellphone
      };
      
      await api.put(`/candidate-profiles/${candidateId}`, data);
      toast.success('Perfil atualizado com sucesso!');
      onSave();
    } catch (error: any) {
      toast.error(error.response?.data?.error || 'Erro ao salvar perfil');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.title}>Editar Perfil do Candidato</h2>
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.row}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Nome:</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={styles.input}
              />
            </div>
            
            <div style={styles.inputGroup}>
              <label style={styles.label}>Sobrenome:</label>
              <input
                type="text"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Data de Nascimento:</label>
            <input
              type="date"
              value={birthdate}
              onChange={(e) => setBirthdate(e.target.value)}
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Descrição:</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={styles.textarea}
              rows={4}
            />
          </div>

          <h3 style={styles.sectionTitle}>Endereço</h3>
          
          <div style={styles.row}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Rua:</label>
              <input
                type="text"
                value={street}
                onChange={(e) => setStreet(e.target.value)}
                style={styles.input}
              />
            </div>
            
            <div style={styles.inputGroup}>
              <label style={styles.label}>Número:</label>
              <input
                type="text"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Complemento:</label>
              <input
                type="text"
                value={complement}
                onChange={(e) => setComplement(e.target.value)}
                style={styles.input}
              />
            </div>
            
            <div style={styles.inputGroup}>
              <label style={styles.label}>CEP:</label>
              <input
                type="text"
                value={zip}
                onChange={(e) => setZip(e.target.value)}
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Bairro:</label>
              <input
                type="text"
                value={neighborhood}
                onChange={(e) => setNeighborhood(e.target.value)}
                style={styles.input}
              />
            </div>
            
            <div style={styles.inputGroup}>
              <label style={styles.label}>Cidade:</label>
              <input
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Estado:</label>
              <input
                type="text"
                value={state}
                onChange={(e) => setState(e.target.value)}
                style={styles.input}
              />
            </div>
            
            <div style={styles.inputGroup}>
              <label style={styles.label}>Celular:</label>
              <input
                type="text"
                value={cellphone}
                onChange={(e) => setCellphone(e.target.value)}
                style={styles.input}
              />
            </div>
          </div>


          
          <div style={styles.buttons}>
            <button
              type="button"
              onClick={onCancel}
              style={styles.cancelBtn}
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              style={styles.saveBtn}
            >
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: colors.white,
    padding: '2rem',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    overflow: 'auto',
  },
  title: {
    margin: '0 0 1.5rem 0',
    color: colors.primary,
  },
  sectionTitle: {
    margin: '1.5rem 0 1rem 0',
    color: colors.primary,
    fontSize: '1.2rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
  row: {
    display: 'flex',
    gap: '1rem',
  },
  inputGroup: {
    marginBottom: '1rem',
    flex: 1,
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    color: colors.text,
    fontWeight: '500',
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '4px',
    fontSize: '1rem',
    fontFamily: 'inherit',
    boxSizing: 'border-box' as const,
  },
  textarea: {
    width: '100%',
    padding: '0.75rem',
    border: `1px solid ${colors.border}`,
    borderRadius: '4px',
    fontSize: '1rem',
    fontFamily: 'inherit',
    boxSizing: 'border-box' as const,
    resize: 'vertical' as const,
  },
  buttons: {
    display: 'flex',
    gap: '1rem',
    marginTop: '1rem',
  },
  cancelBtn: {
    flex: 1,
    padding: '0.75rem',
    backgroundColor: colors.border,
    color: colors.text,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '1rem',
  },
  saveBtn: {
    flex: 1,
    padding: '0.75rem',
    backgroundColor: colors.primary,
    color: colors.white,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '1rem',
  },
};

export default CandidateProfileForm;